import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
import { VERIFY_AUTH } from "@/core/services/store/auth.module";
// import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";

Vue.config.productionTip = false;
import VueFileAgent from "vue-file-agent";

Vue.use(VueFileAgent);

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";

Vue.use(require("vue-moment"));

import Vue2Editor from "vue2-editor";
Vue.use(Vue2Editor);

import PerfectScrollbar from "perfect-scrollbar";

window.PerfectScrollbar = PerfectScrollbar;

import ClipboardJS from "clipboard";

window.ClipboardJS = ClipboardJS;

import UploadImage from "vue-upload-image";

// register globally
Vue.component("upload-image", UploadImage);
// Vue 3rd party plugins

import vuetify from "@/core/plugins/vuetify";
import StarRating from "vue-star-rating";

import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/collapse";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/metronic";

// API service init
ApiService.init();
console.log("router", router);
router.beforeEach((to, from, next) => {
  // Ensure we checked auth before each page load.
  //if (!to.query.t) {
  //console.log("TO", to);
  Promise.all([store.dispatch(VERIFY_AUTH)])
    .then(next)
    .catch((err) => {
      console.log(err);
    });
  //}
  // else {
  //   console.log("next");
  //   next;
  // }

  //console.log("After Promise Verify ROUTER ");
  // if(!store.state.isAuthenticated &&){
  //     console.log(to);
  //     router.push({name: "login"});
  // }
  // reset config to initial state
  //store.dispatch(RESET_LAYOUT_CONFIG);
  //console.log(ApiService);
  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

new Vue({
  router,
  store,
  vuetify,
  StarRating,
  components: {
    UploadImage,
  },
  render: (h) => h(App),
}).$mount("#app");
